document.addEventListener('DOMContentLoaded', function() {
  const productFeedTabs = document.querySelectorAll('product-feed');

  productFeedTabs.forEach(feedTab => {
    const navButtons = feedTab.querySelectorAll('.product__feed-tabs--nav-btn');
    const contentBoxes = feedTab.querySelectorAll('.product__feed-tabs--content-box');

    navButtons.forEach(button => {
      button.addEventListener('click', function() {
        const targetId = this.getAttribute('data-target');

        navButtons.forEach(btn => btn.classList.remove('tabs--nav-btn-active'));
        this.classList.add('tabs--nav-btn-active');

        contentBoxes.forEach(box => {
          box.classList.toggle('tabs--content-active', box.id === targetId);
        });
      });
    });
  });
});
